import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ButtonDesign from "../ButtonDesign/ButtonDesign";

import "./ServiceCardFull.css";

const ServiceCardFull = ({ data }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleNavigation = (page) => {
		navigate("/portafolio/" + page.toLowerCase());
	};

	return (
		<div
			className="service-card-full-container"
			key={data["id"]}
			id={data["id"]}
		>
			<div className="service-card-full-icon">
				<img
					alt={data["alt"]}
					src={require("../../assets/" + data["icon"])}
					className="service-card-full-icon-img"
				/>
			</div>
			<div className="service-card-full-name">
				<h3 className="service-card-full-name-text">{data["name"]}</h3>
			</div>
			<div className="service-card-full-description">
				<h5 className="service-card-full-description-text">
					{data["description"]}
				</h5>
			</div>
			<div className="service-card-full-button">
				<ButtonDesign
					data={{
						text: t("services.projectsMore"),
						dynamic: false,
					}}
					handleClick={() => handleNavigation(data["type"])}
				/>
			</div>
		</div>
	);
};

export default ServiceCardFull;
